import { FormRule } from "antd";
import { t } from "i18next";

export const ruleEmail = (): FormRule => ({
  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  message: t("Invalid email format") || "",
});
